var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSegmentView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V26H26V0H0ZM11.5334 4.76466L16.2986 8.19819L11.5334 11.5083V4.76466ZM24.4706 24.4706H1.52941V16.0588H24.4706V24.4706ZM24.4706 14.584H1.52941V1.52941H24.4706V14.584Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94336 18.0701H13.9107V19.5995H8.94336V18.0701Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94336 20.9912H16.6838V22.5206H8.94336V20.9912Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.334 18.0701H18.0329V19.5995H15.334V18.0701Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79297 18.0701H7.41167V22.5207H3.79297V18.0701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentView);
export default __webpack_public_path__ + "static/media/segment_view.a7c8890da5e14ae54a6c868b9039cbe8.svg";
export { ForwardRef as ReactComponent };